<form class="no-padding" [formGroup]="supplierInvoiceOrderLinkForm" id="supplierInvoiceOrderLinkForm" (ngSubmit)="onSubmit()">
    <div class="grid bgc-neutral-100 p-24 mb-24 ">
      <div class="d-flex flex-column gap-18 g-col-6">
        <div><span class="fc-neutral-800 fw-500">{{'SUPPLIER' | translate | uppercase }}</span></div>
        <div> {{ supplierInvoiceSection()?.supplierName}} </div>
      </div>
      <div class="d-flex flex-column gap-18 g-col-6"  >
        <div><span class="fc-neutral-800 fw-500">{{'DELIVERY_ADDRESS' | translate | uppercase }}</span></div>
        <div> {{ supplierInvoiceSection()?.documentDeliveryAddressString | uppercase}} </div>
      </div>
    </div>
      <div class="card-body">
            <rc-client-order-table class="mb-24" (clientOrderSelection)="patchClientOrder($event)" [section]="supplierInvoiceSection()!" [initialValue]="supplierInvoiceSection()?.clientOrder" [selectedOrder]="selectedClientOrder()"></rc-client-order-table>
        </div>
</form>
<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button kendoButton class="g-start-10 string-button" (click)="close()">
      {{ "CANCEL" | translate | capitalize }}
    </button>
    <button
      [disabled]="supplierInvoiceOrderLinkForm.invalid"
      class="g-col-2 g-start-11"
      kendoButton
      type="submit"
      form="supplierInvoiceOrderLinkForm"
      [iconClass]="'rc-icon-row-insert-bottom'"
      [themeColor]="'primary'">
      {{ "ASSOCIATE" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
